import { Link } from 'react-router-dom';
import { InvoyssLogo } from '@/features/brand/InvoyssLogo';

interface AuthLayoutProps {
  title: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/**
 * Shared auth-page chrome. Centred card on a warm canvas with the
 * brand mark up top and a footer slot for "Already have an account?"
 * style links. Editorial type sets the tone for first impressions.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center bg-background px-4 py-12">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[420px] bg-gradient-to-b from-accent-soft to-transparent"
        aria-hidden
      />
      <Link to="/" className="mb-8">
        <InvoyssLogo size="lg" />
      </Link>
      <main className="w-full max-w-md rounded-2xl border border-line bg-card p-8 shadow-[0_24px_60px_-30px_rgb(0_0_0/0.18)]">
        <div className="mb-6 flex flex-col gap-2 text-left">
          <h1 className="font-display text-2xl font-semibold tracking-tight text-foreground">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
          ) : null}
        </div>
        {children}
      </main>
      {footer ? (
        <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>
      ) : null}
    </div>
  );
}
